import React from "react";
import "./styles.scss";

export default class sliderSelectBar extends React.Component {
  render() {
    var progress = this.props.progress;
    var style = this.props.style || "default";

    return (
      <div className={`sliderSelectBar ${style}`}>
        <div className="content">
          <div className="progress" style={{ width: progress + "%" }}></div>
        </div>
        <div
          className="handler"
          style={{ left: "calc(" + progress + "% - 12px)" }}
        ></div>
      </div>
    );
  }
}
